import { render } from "./Main.vue?vue&type=template&id=ff8bd27a"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script